import { LoginPage as KitLoginPage, type LoginPageLabels } from 'auth-sso-kit/client';
import { useT } from '../i18n';

export function LoginPage() {
  const { t } = useT();

  const labels: LoginPageLabels = {
    emailLabel: t('login.emailLabel'),
    passwordLabel: t('login.passwordLabel'),
    passwordPlaceholder: t('login.passwordPlaceholder'),
    submitLabel: t('login.submit'),
    submittingLabel: t('login.submitting'),
    footerOpen: t('login.footerOpen'),
    footerAllowlist: t('login.footerAllowlist'),
    errEmailRequired: t('login.errEmailRequired'),
    errPasswordRequired: t('login.errPasswordRequired'),
    errLoginFailed: t('login.errLoginFailed'),
    errNotAuthorized: t('login.errNotAuthorized'),
    errOidcFailed: t('login.errOidcFailed'),
    errNoEmail: t('login.errNoEmail'),
  };

  return (
    <KitLoginPage
      title="PMO"
      subtitle={t('login.subtitle')}
      oidcButtonLabel={t('login.oidcButton')}
      emailPlaceholder="your.name@aeveil.ch"
      labels={labels}
    />
  );
}
